
import '../libs/serialize/serialize.js'
import {espCalendar, cambioSede, initModal, createLoader, afterSubmit, obtenerCaptcha} from './include/global.js'
import {validar_info,
        validar_simulador}     from './include/validations.js'

Number.prototype.formatMoney = function(c, d, t){
    //ejemplo (0,",",".")
    var n = this, 
        c = isNaN(c = Math.abs(c)) ? 2 : c, 
        d = d == undefined ? "." : d, 
        t = t == undefined ? "," : t, 
        s = n < 0 ? "-" : "", 
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
        j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 }

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}


$(document).ready(function(){
	let _initModal 	= initModal(isMovil)

    if($('#big-banner').length != 0){
        let carousel = $('#big-banner').carousel({
            fullWidth: true,
            indicators: true
        });
    }

    if($('.datepicker').length != 0){
        $('.datepicker').datepicker({container: $('body').get(0), format: 'dd/mm/yyyy', i18n: espCalendar(), minDate: (new Date()).addDays(1), maxDate: (new Date()).addDays(365)});
    }

    $('body').on('click','.button-set button',function(event){
        event.preventDefault();
        var instance = M.Carousel.getInstance($(this).parents('.carousel').first().get(0));
        if($(this).data('type') == "prev") 
            instance.prev()
        else if($(this).data('type') == "next") 
            instance.next()
    })


	$('select').formSelect()
	$('.dropdown-trigger').dropdown({constrainWidth: false, alignment: 'bottom'});
	$('.tooltipped').tooltip();

    if($('.sidenav').length != 0){
        $('.sidenav').sidenav();
        $('.collapsible').collapsible();
    }

	$('.modal.all').modal(_initModal)

    if($('#reservas').length != 0){
        cambioSede(locales, $('#reservas [name="idResp"]').val(), undefined, $('#reservas [name="idTEvento"]'), undefined, undefined, undefined)
        $('#reservas [name="idResp"]').on('change', function(){
            cambioSede(locales, $(this).val(), undefined, $('#reservas [name="idTEvento"]'), $('#reservas [name="ninvAd"]'), $('#reservas [name="ninvNi"]'), undefined)
        })
    }

    if($('#form-info').length != 0){
        obtenerCaptcha('form-info');    
    }
    
    if($('#form-simulador').length != 0){
        obtenerCaptcha('form-simulador');    
    }




    $('#form-reserva'
        +   ', #form-info'
        +   ', #form-simulador').on('submit', function(event){
        event.preventDefault()
        $('[data-send="'+ $(this).attr('id') + '"]').click()
    })

    $('[data-send]').on('click', function(event){
        event.stopPropagation()
        event.preventDefault()
        let $este           = $(this)
        if($este.attr('data-disable') == 'true') return false
        let id              = $este.attr('data-send')
        ,   status_val      = {status: false}
        ,   instance_mod    = undefined

        $este.attr('data-disable', 'true')
        switch (id) {
            case'form-reserva':
                status_val      = validar_simulador($('#form-reserva'))
                instance_mod    = M.Modal.getInstance($('#reservas').get(0))
                break;
            case 'form-info':
                status_val      = validar_simulador($('#form-info'))                
                break;
            case 'form-simulador':
                status_val      = validar_simulador($('#form-simulador'))                
                break;
        }

        if(status_val.status){
            let $form   = $('#' + id)
            ,   args    = $form.serializeObject()

            $.ajax({
                url     : $form.attr('action'),
                type    : 'POST',
                data    : args,
                dataType: 'json',
                beforeSend: function(){
                    createLoader(true)                   
                },
                success: function(data){
                    createLoader(false)                  
                    afterSubmit(data, instance_mod, $form, $este)
                },
                error: function(xhr, status){
                    console.log(xhr.responseText)
                    M.toast({html: 'Ocurrió un error inesperado. Intenta nuevamente más tarde'})
                    createLoader(false)  
                    $este.attr('data-disable', 'false') 
                }
            })
        }
        else{
            $(this).attr('data-disable', 'false')
        }
    });
})






// WEBPACK FOOTER //
// ./src/js/general.js